import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";

var mutation = gql`
  mutation createFormTemplate($organizationId: UUID!, $typeId:  UUID!, $title: String!) {
    createFormTemplate(organizationId: $organizationId, typeId: $typeId, title: $title) {
      id
    }
  }  
`;



export function apiCreateFormTemplate(organizationId, typeId, title) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        client
            .mutate({
                mutation: mutation,
                variables: {organizationId, typeId, title},
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.CreateFormTemplate);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to create template");
                reject(err); // R
            })
    });
}


